/**
 * 会社名・勤務地・駅情報
 *
 * @param props
 * @return {JSX.Element|null}
 * @constructor
 */
export const SimpleJobSummary = (props) => {

    if (!props.viewedJob.companyName && !props.viewedJob.locations && !props.viewedJob.stationName) {
        return null;
    }

    // 旧形式のデータを新形式に変換
    const locations = props.viewedJob.locations || (props.viewedJob.location ? [props.viewedJob.location] : []);

    const jobSummaryList = [];
    if (props.viewedJob.companyName) {
        jobSummaryList.push(
            <li className="p-job_companyName" key='companyName'>
                <img src="/webfront/images/icon/company_gray.svg" className="p-job_summary_img" width="11" height="17" alt={props.translations.company} />
                {props.viewedJob.companyName}
            </li>
        );
    }
    if (locations && locations.length > 0 && locations[0]) {
        jobSummaryList.push(
            <li className="p-job_location s-more_list_wrap" key='location'>
                <img src="/webfront/images/icon/location_gray.svg" className="p-job_summary_img" width="11" height="17" alt={props.translations.location} />
                {locations.map((location, idx) => (
                    <span className="c-more_list s-more_list" key={idx}>{location}</span>
                ))}
                <p className="p-job_location_more_text s-more_text"> + <span className="s-more_num"></span> <span className="s-more_loc">{props.translations.other_locations}</span></p>
            </li>
        );
    }
    if (props.viewedJob.stationName) {
        jobSummaryList.push(
            <li className="p-job_station" key="stationName">
                <img src="/webfront/images/icon/station_gray.svg" className="p-job_summary_img" width="11" height="17" alt={props.translations.station} />
                <div>
                    {props.viewedJob.stationName}{' '}
                    <span className="p-job_summary_train">
                        {props.viewedJob.trainList && Object.values(props.viewedJob.trainList).length > 0 && (Object.values(props.viewedJob.trainList).map((train) => (
                            <img key={train.id} src={`/webfront/images/train/train_${train.id}.svg`} width="17" height="17" alt={train.name}/>),
                        ))}
                    </span>
                </div>
            </li>
        );
    }

    return (
        <ul className="p-job_summary">
            {jobSummaryList}
        </ul>
    );
}
